//src/pages/OpenBookPagesList.jsx
import React, { useCallback, useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import useFetch from '../../hooks/useFetch';
import 'react-datepicker/dist/react-datepicker.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import Loader from '../../components/utils/Loader';
import Tooltip from '../../components/utils/Tooltip';
import MainLayout from '../../layouts/MainLayout';

const JEENEETOpenBookPagesList = () => {
  const authState = useSelector(state => state.authReducer);
  const { isLoggedIn } = authState;
  const [openBookPages, setOpenBookPages] = useState([]);
  const [fetchData, { loading }] = useFetch();
  const [selectedOpenBookPageId, setSelectedOpenBookPageId] = useState(null);
  const [deletePageId, setDeletePageId] = useState(null); 

  useEffect(() => {
    document.title = authState.isLoggedIn ? `${authState.user.name}'s dashboard` : "Think5Whys";
  }, [authState]);


  const fetchOpenBookPages = useCallback(() => {
    const config = {
        url: "/useropenbookpages/mypagesfull",    //mypagesfull
        method: "post",
        headers: { Authorization: authState.token },
        data: { userId: authState.user._id}
      };
      
    // console.log("Open Text Book Search Payload: ", config);
  
    fetchData(config, { showSuccessToast: false }).then(data => setOpenBookPages(data.userOpenBookPages));
  }, [authState.token, fetchData, authState.user._id]);
  
  useEffect(() => {
    if (!authState.isLoggedIn) return;
    fetchOpenBookPages();
  }, [authState.isLoggedIn, fetchOpenBookPages]);

  const [isDeleteClicked, setIsDeleteClicked] = useState(false);
  
  const deleteClicked = (id) => {
    setDeletePageId(id);
    setIsDeleteClicked(true);
  }
  
  const noDeleteClicked = () => {
    setIsDeleteClicked(false);
  }

  const handleDelete = (id) => {
    // console.log("ID to delete: ",id);
    const config = {
      url: `/useropenbookpages/${id}`,
      method: "delete",
      headers: { Authorization: authState.token }
    };
    fetchData(config).then(() => fetchOpenBookPages());
    setIsDeleteClicked(false);
  }

  const handleView = (openBookPageId) => {
    setSelectedOpenBookPageId(prevId => (prevId === openBookPageId ? null : openBookPageId));
  };

  const handleOpenBookPageShare = (openBookPageId) => {
    setSelectedOpenBookPageId(openBookPageId);
  };

  const handleOpenBookPageSave = (openBookPageId) => {
    setSelectedOpenBookPageId(openBookPageId);
  };

  const handleOpenBookPagePrint = (openBookPageId) => {
    setSelectedOpenBookPageId(openBookPageId);
  };

  const formatDateTime = (date) => {
    const options = {
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false
    };
    const jsDate = new Date(date);
    const day = jsDate.getDate().toString().padStart(2, '0');
    const month = (jsDate.getMonth() + 1).toString().padStart(2, '0');
    const year = jsDate.getFullYear();
    const hours = jsDate.getHours().toString().padStart(2, '0');
    const minutes = jsDate.getMinutes().toString().padStart(2, '0');
    const seconds = jsDate.getSeconds().toString().padStart(2, '0');
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

const sortedOpenBookPages = [...openBookPages].sort((a, b) => b.pageNumber - a.pageNumber);
const pageNumberList = openBookPages.map(page => page.pageNumber);

  return (
    <>
      <MainLayout>
        <div className="min-h-full py-8 bg-gradient-to-r from-purple-300 via-blue-500 to-yellow-200 mt-12">
          <h2 className='text-3xl font-bold text-white text-center mb-2'>My Own Open Text Book Pages</h2>
{/* {pageNumberList && Array.isArray(pageNumberList) && pageNumberList.length > 0 ? (
  <ul>
    {pageNumberList.map((pageNumber, index) => (
      <li key={index}>
        {pageNumber},
      </li>
    ))}
  </ul>
) : (
  <p>No pages available</p>
)}     */}
            <div className="border border-gray-300 p-4 mt-4">
              <div className="mt-2">
                  {openBookPages && openBookPages.length !== 0 && (
                    <div className="flex justify-between items-center border-b border-b-gray-300">
                      <div>
                      <h3 className='text-m mt-1 mx-1 text-yellow-200'>{openBookPages.length} Page Found!</h3>
                      </div>
                      <div className='mr-4'>
                      {/* <Link to='/opentextbook/add' className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'>
                        <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Setup A Page
                      </Link> */}
                      <Link
                          to={`/opentextbook/add`}
                          state={{ pageNumberList: pageNumberList }}
                          className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'
                        >
                          <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Setup A Page
                      </Link>
                    </div>
                  </div>
                  )}
              </div>
              {loading ? (
                <Loader />
              ) : (
                <div>
                  {openBookPages && openBookPages.length === 0 ? (
                    <div className='min-h-[300px] flex items-center justify-center gap-4 text-yellow-300'>
                      <div className="flex justify-between items-center">
                        <h3 className='text-lg mt-1 mx-2 text-orange-400'>Your Own Page Not Found!</h3>
                        <div>
                          {/* <Link to='/opentextbook/add' className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'>
                            <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Setup A Page
                          </Link> */}
                          <Link
                              to={`/opentextbook/add`}
                              state={{ pageNumberList: pageNumberList }}
                              className='block w-full h-full px-1 py-2 ml-4 bg-blue-500'
                            >
                              <FontAwesomeIcon className="bg-blue-500 mr-4" icon={faPlus} />  Setup A Page
                          </Link>
                        </div>
                    </div>
                  </div>
                  ) : (
                    sortedOpenBookPages.map((openBookPage, index) => (
                      <div key={openBookPage._id} className='bg-gray-600 my-1 p-1 text-white rounded-md shadow-md text-sm'>
                        <div className='flex'>
                          <span className='font-medium'>{openBookPage.pageNumber}{'. '}{openBookPage.pageTitle}</span>
                          <Tooltip text={"View details"} position={"top"}>
                            <span className='ml-auto mr-4 text-blue-500 cursor-pointer' onClick={() => handleView(openBookPage._id)}>
                              <i className="fa-solid fa-eye"></i>
                            </span>
                          </Tooltip>
                          <Tooltip text={"Edit this record"} position={"top"}>
                            <Link
                              to={`/opentextbook/${openBookPage._id}`}
                              state={{ pageNumberList: pageNumberList }}
                              className='mr-4 text-green-600 cursor-pointer'
                            >
                              <i className="fa-solid fa-pen"></i>
                            </Link>
                          </Tooltip>
                          <Tooltip text={"Delete this record"} position={"top"}>
                            <span className='text-red-500 cursor-pointer mr-2' onClick={() => deleteClicked(openBookPage._id)}>
                              <i className="fa-solid fa-trash"></i>
                            </span>
                          </Tooltip>
                          { isDeleteClicked && (
                            <div
                              className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center"
                              style={{ zIndex: 1000 }}
                            >
                              <div className="w-6/12 flex flex-row justify-center bg-blue-200 text-black border-b border-b-gray-300 mr-4 ml-4 p-4">
                                  <button
                                    className="bg-red-700 w-40"
                                    onClick={() =>  handleDelete(deletePageId) }
                                    style={{ maxWidth: "150px" }}
                                  >
                                    Confirm To Delete
                                  </button>
                                  <button
                                    className="bg-yellow-300 ml-4 text-black w-40"
                                    onClick={() =>  noDeleteClicked() }
                                    style={{ maxWidth: "150px" }}
                                  >
                                    No I Do Not Want To Delete
                                  </button>
                              </div>
                            </div>
                          )}
                        </div>
                        {selectedOpenBookPageId === openBookPage._id && (
                          <div className='bg-gray-600 text-white'>
                            <p className='bg-blue-700 text-white justify-center text-m mt-2 mb-2'>
                              <h2 className='text-white'><strong>Page Details</strong></h2>
                            </p>
                            <p><strong>Page#:</strong> {openBookPage.pageNumber}</p>
                            <p><strong>Page Title:</strong> {openBookPage.pageTitle}</p>
                            <p className='border-2 border-lime-600 px-4 py-4'><strong className='text-yellow-200'>Page Content:</strong>  <br/>
                              <div
                                className="ml-2 mr-2 flex items-start"
                                style={{ minHeight: "100%", position: 'relative', top: 0, left: 0, right: 0 }}
                                dangerouslySetInnerHTML={{ __html: openBookPage.pageContent }}
                              />
                            </p>
                            <p><strong>Is Hidden Text:</strong> {openBookPage.isSplText === 1 ? "Yes":"No"}</p>
                            <p className='border-2 border-lime-600 px-4 py-4'><strong className='text-yellow-200'>Hidden Text:</strong><br/>
                              {openBookPage.splTextContent}
                            </p>
                            <p><strong>Speak Hidden Text:</strong> {openBookPage.readFromSplText ? "Yes":"No"}</p>
                            <p><strong>Show Page Video:</strong> {openBookPage.hasVideo ? "Yes":"No"}</p>
                            <p><strong>Video URL:</strong> {openBookPage.videoURL}</p>
                            <p><strong>Page Keywords:</strong> {openBookPage.searchTags}</p>
                            <p><strong>Date Created:</strong> {formatDateTime(openBookPage.createdDate)}</p>
                            <p><strong>Creator Name:</strong> {openBookPage.createdByName}</p>

                            <Tooltip text={"Share"} position={"top"}>
                              <span className='text-green-500 cursor-pointer mr-4' disabled={true} onClick={() => handleOpenBookPageShare(openBookPage._id)}>
                                <i className="fa-solid fa-share"></i>
                              </span>
                            </Tooltip>
                            <Tooltip text={"Save"} position={"top"}>
                              <span className='text-blue-500 cursor-pointer mr-4' disabled={true} onClick={() => handleOpenBookPageSave(openBookPage._id)}>
                                <i className="fa-solid fa-save"></i>
                              </span>
                            </Tooltip>
                            <Tooltip text={"Print"} position={"top"}>
                              <span className='text-orange-500 cursor-pointer mr-4' disabled={true} onClick={() => handleOpenBookPagePrint(openBookPage._id)}>
                                <i className="fa-solid fa-print"></i>
                              </span>
                            </Tooltip>
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
              )}
            </div>
          </div>
      </MainLayout>
    </>
  )
}

export default JEENEETOpenBookPagesList